import React from 'react';
const points = ['Sei stanco di sacrificare i tuoi weekend per scrivere progettazioni e verbali.', 'Arrivi a casa esausto e devi ancora preparare le slide per la lezione di domani.', 'Senti che i tuoi alunni sono annoiati dai vecchi libri di testo troppo testuali.', 'Vuoi presentare al Dirigente un programma artistico moderno e di alto livello.'];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-96">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.08) 0%, transparent 70%)'
    }} data-id="element-97"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-98">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-12 text-center tracking-tight" data-id="element-99">
          Questa risorsa è per te se...
        </h2>

        <div className="space-y-4" data-id="element-100">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group" data-id="element-101">
              <div className="w-8 h-8 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 group-hover:bg-check-green group-hover:border-check-green transition-colors shadow-[0_0_10px_rgba(16,185,129,0.2)]" data-id="element-102">
                <span className="text-check-green group-hover:text-white text-sm font-bold transition-colors" data-id="element-103">
                  ✓
                </span>
              </div>
              <p className="text-text-main text-lg font-medium leading-relaxed" data-id="element-104">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}